import { render, staticRenderFns } from "./RemoteConsulations.vue?vue&type=template&id=a5310b44&"
import script from "./RemoteConsulations.vue?vue&type=script&lang=js&"
export * from "./RemoteConsulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports